module.exports = __webpack_public_path__ + "static/media/carousel2bg.ba935290.png";